import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './custom-event-polyfill';

import axios from 'axios';
import * as singleSpa from 'single-spa';
import { globalEventDistributor } from './globalEventDistributor';
import { loadApp } from './helper.js';

export async function init() {
    const loadingPromises = [];

    window['DashboardV2'] = window['DashboardV2'] || {};
    window['DashboardV2']['globalEventDistributor'] = globalEventDistributor();

    try {
        const { data } = await axios.get(`${process.env.LAMBDA_PRODUCTS_URL}`);
        const productsConfiguration = data;

        let assetVersionPromises = Object.keys(productsConfiguration).map(async key => {
            const product = productsConfiguration[key];

            if (product.assetsName) {
                const testPromise = axios.get(`${process.env.CDN_URL}/${product.folderName}/${product.assetsName}`, {
                    headers: {
                        'Cache-Control': 'no-store, no-cache, must-revalidate',
                    },
                });

                return testPromise;
            }
        });

        let caughtPromises = assetVersionPromises.map(promise => promise.catch(e => e));

        let assetVersions = await Promise.all(caughtPromises);
        let position = 0;

        Object.keys(productsConfiguration).map(async key => {
            const product = productsConfiguration[key];

            let assetVersion = assetVersions[position] ? `/${assetVersions[position]['request']['response']}` : '';
            assetVersion = assetVersion.replace(/(\r\n|\n|\r)/gm, '');

            loadingPromises.push(
                loadApp(
                    product.name,
                    product.hash,
                    product.entrypointName ? `${product.url}${assetVersion}/${product.entrypointName}` : null,
                    product.storeName ? `${product.url}${assetVersion}/${product.storeName}` : null,
                    product.hasGlobalEventDistributor ? window.DashboardV2.globalEventDistributor : null
                )
            );

            ++position;
        });

        await Promise.all(loadingPromises);

        singleSpa.start();
    } catch (error) {
        console.log(error);
    }
}
